import React, { useState, useEffect } from 'react';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';

const ConnectionStatus: React.FC = () => {
  const isOnline = useNetworkStatus();
  const [showOfflineMessage, setShowOfflineMessage] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setShowOfflineMessage(true);
    } else {
      // Mostrar mensaje de reconexión brevemente
      if (showOfflineMessage) {
        const timer = setTimeout(() => {
          setShowOfflineMessage(false);
        }, 3000);
        return () => clearTimeout(timer);
      }
    }
  }, [isOnline, showOfflineMessage]);

  if (!showOfflineMessage) return null;

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isOnline 
        ? 'bg-green-600 text-white' 
        : 'bg-red-600 text-white'
    }`}>
      <div className="container mx-auto px-4 py-2 text-center text-sm">
        {isOnline ? (
          <div className="flex items-center justify-center space-x-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span>Conexión restablecida</span>
          </div>
        ) : (
          <div className="flex items-center justify-center space-x-2">
            <svg className="w-4 h-4 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Sin conexión a internet. Verificando...</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConnectionStatus;